<template>
  <span v-if="
    claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD'] ||
    claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE']
  ">
    <v-menu
      v-if="selectedCompany"
      offset-y
      left
      fixed
    >
      <a
        :title="$t(`${namespace}.massActions`)"
        class="action-bar__link action-bar__link--icon"
        slot="activator"
        @click.prevent
      >
        {{ $t(`${namespace}.massActions`) }}
        <v-icon color="accent">keyboard_arrow_down</v-icon>
      </a>

      <v-list class="dropdown-menu-actions__list">
        <v-list-tile
          v-if="claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_UPLOAD']"
          @click="$router.push({ name: 'EmployeeBulkOperation' })"
        >
          {{ $t(`${namespace}.addCollaboratorsBulk`) }}
        </v-list-tile>

        <v-list-tile
          v-if="claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE']"
          @click="supervisorBulkUpdateDialog = true"
        >
          {{ $t(`${namespace}.updateBulkSupervisor`) }}
        </v-list-tile>

        <v-list-tile
          v-if="claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE']"
          @click="setWebCallPermissionBulkDialog = true"
        >
          {{ $t(`${namespace}.updateBulkWebCall`) }}
        </v-list-tile>

        <v-list-tile
          v-if="claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE']"
          @click="categoryPermissionBulkDialog = true"
        >
          {{ $t(`${namespace}.updateBulkCategories`) }}
        </v-list-tile>

        <v-list-tile
          v-if="claims.company['ROLE_POST_COMPANY_ID_EMPLOYEE_BATCHUPDATE']"
          :to="{ name: 'EmployeeMassCreditPolicy' }"
        >
          {{ $t(`${namespace}.updateBulkUsagePolicy`) }}
        </v-list-tile>

        <v-list-tile
          v-if="claims.company['ROLE_DELETE_COMPANY_COMPANYID_EMPLOYEES_MULTIDELETE']"
          @click="openExcludeEmployeesByIDDialog"
        >
          {{ $t(`${namespace}.excludeEmployeesByID`) }}
        </v-list-tile>
      </v-list>
    </v-menu>

    <span v-else>
      <v-tooltip min-width="177" max-width="177" top>
        <a href="#" class="action-bar__link action-bar__link--icon" slot="activator" @click.prevent>
          {{ $t(`${namespace}.massActions`) }}
          <v-icon color="accent">keyboard_arrow_down</v-icon>
        </a>
        {{ $t('Common.selectCompany') }}
      </v-tooltip>
    </span>

    <SupervisorBulkUpdateDialog
      :visible="supervisorBulkUpdateDialog"
      @close="supervisorBulkUpdateDialog = false"
    />

    <SetWebCallPermissionBulkDialog
      :visible="setWebCallPermissionBulkDialog"
      @close="setWebCallPermissionBulkDialog = false"
    />

    <CategoryPermissionBulkDialog
      :visible="categoryPermissionBulkDialog"
      @close="categoryPermissionBulkDialog = false"
    />

    <ExcludeEmployeesByIDDialog
      :visible="excludeEmployeesByIDDialog"
      @close="excludeEmployeesByIDDialog = false"
      @reloadData="$emit('reloadData')"
    />
  </span>
</template>

<script>
import { mapState } from 'vuex'

// dialogs
import SupervisorBulkUpdateDialog from 'components/employees/dialogs/SupervisorBulkUpdate'
import SetWebCallPermissionBulkDialog from 'components/employees/dialogs/SetWebCallPermissionBulk'
import CategoryPermissionBulkDialog from 'components/employees/dialogs/CategoryPermissionBulk'
import ExcludeEmployeesByIDDialog from 'components/employees/dialogs/ExcludeEmployeesByIDDialog'

export default {
  name: 'BulkActions',
  components: {
    SupervisorBulkUpdateDialog,
    SetWebCallPermissionBulkDialog,
    CategoryPermissionBulkDialog,
    ExcludeEmployeesByIDDialog
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',

      // dialogs
      supervisorBulkUpdateDialog: false,
      setWebCallPermissionBulkDialog: false,
      categoryPermissionBulkDialog: false,
      excludeEmployeesByIDDialog: false
    }
  },
  methods: {
    openExcludeEmployeesByIDDialog () {
      this.excludeEmployeesByIDDialog = true
    },

    closeExcludeEmployeesByIDDialog () {
      this.excludeEmployeesByIDDialog = false
    }
  }
}
</script>
